// Catálogo central de ferramentas do hub.
// Para adicionar uma nova ferramenta: crie a pasta em src/apps/<id>/
// e adicione uma entrada aqui.

// Reativação dos mapas: trocar esta flag, preservando as rotas e o catálogo.
export const MAPS_ENABLED = false;

export const APPS = [
  {
    id: 'tp',
    name: 'TP',
    description: 'Estime sua nota pelos acertos da prova',
    path: '/TP',
  },
  ...(MAPS_ENABLED ? [{
    id: 'mapa',
    name: 'Mapas conceituais',
    description: 'Raciocínio compartilhado nos GTs',
    path: '/gts/mapa',
  }] : []),
  {
    id: 'horario',
    name: 'Horário',
    description: 'Editor de horário da turma',
    path: '/horario',
  },
  {
    id: 'calendario',
    name: 'Calendário',
    description: 'Datas e eventos acadêmicos da turma',
    path: '/calendario',
  },
];
